import Routes from "src/routes";
import useAuth from "src/hooks/useAuth";
import YellowLogoLoadingSpinner from "src/components/Loader/YellowLogoLoadingSpinner";

export default function AppMainLayout() {
  const { isInitialized } = useAuth();
  return (
    <div className="africast-app">
      {isInitialized ? (
        <Routes />
      ) : (
        <YellowLogoLoadingSpinner sx={{ width: "100%", height: "100vh" }} />
      )}
    </div>
  );
}
